/**
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
**/
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.A4uCropLightning = A4uCropLightning;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function A4uCropLightning(_ref) {
  var props = _extends({}, _ref);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 36 36"
  }, props, props), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M16,27a10.962,10.962,0,0,1,.416-3H12V3a1,1,0,0,0-1-1H9A1,1,0,0,0,8,3V8H3A1,1,0,0,0,2,9v2a1,1,0,0,0,1,1H8V27a1,1,0,0,0,1,1h7.046C16.016,27.671,16,27.337,16,27Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M24,16.416A10.962,10.962,0,0,1,27,16c.337,0,.671.016,1,.046V9a1,1,0,0,0-1-1H14v4H24Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M27,18a9,9,0,1,0,9,9A9,9,0,0,0,27,18Zm4.081,9.748-5.927,6.778a.613.613,0,0,1-1.027-.642l2-4.749L23.3,27.921a1.059,1.059,0,0,1-.379-1.67l5.928-6.777a.613.613,0,0,1,1.026.642l-2,4.749L30.7,26.079A1.058,1.058,0,0,1,31.081,27.748Z"
  }));
}